import parse from 'html-react-parser';

import { Fragment } from 'react';
import Pets from '../Common/icons/Pets';
import Smoke from '../Common/icons/Smoke';
import Cancellation from '../Common/icons/Cancellation';
import ReportIcon from '../Common/icons/ReportIcon';
import Bed3 from '../Common/icons/Bed3';
import Login from '../Common/icons/Login';
import Logout from '../Common/icons/Logout';

const AccomodationPolicy = props => {

    const { policies, mendatoryFee } = props;


    if (!policies?.length) {
        return null;
    }

    const checkinTime = policies.find(policy => policy.keyword === 'check-in')?.value;
    const checkoutTime = policies.find(policy => policy.keyword === 'check-out')?.value;

    return (
        <>
            <h5 className="normal-title">قوانین و مقررات</h5>
            <div className="card box-border margin-bottom bg-white card-padding">
                <div className="float-row large-gap">

                    {!!(checkinTime && checkoutTime) && <div className="col-small-12 col-medium-3">
                        <div className="pair-row">
                            <span><Login className='inline-block-middle margin-end-light' /> زمان ورود</span>
                            <span>{checkinTime}</span>
                        </div>
                        <div className="pair-row margin-top-half">
                            <span><Logout className='inline-block-middle margin-end-light' /> زمان خروج</span>
                            <span>{checkoutTime}</span>
                        </div>
                    </div>}

                    <div className={`domestic-hotel-rules-list col-small-12 col-medium-9`}>

                        {policies.filter(policy => (policy.keyword && !['check-in', 'check-out'].includes(policy.keyword))).map((policy, index) => <Fragment key={policy.keyword}>

                            {!!index && <hr className='margin-top margin-bottom' />}

                            <div className='semi-bold margin-bottom-half font-15'>

                                {!!(policy.keyword === 'pets') && <Pets className='inline-block-middle margin-end-light' />}
                                {!!(policy.keyword === 'smoking') && <Smoke className='inline-block-middle margin-end-light' />}
                                {!!(policy.keyword === 'cancellation') && <Cancellation className='inline-block-middle margin-end-light' />}
                                {!!(policy.keyword === 'damage-policy') && <ReportIcon className='inline-block-middle margin-end-light' />}
                                {!!(policy.keyword === 'children-and-bed') && <Bed3 className='inline-block-middle margin-end-light' />}

                                {policy.name}

                            </div>

                            {policy.value ? (
                                <div>
                                    {policy.value}
                                </div>
                            ) : (
                                <div>

                                    {policy.description ? parse(policy.description) : ""}

                                    {!!(policy.passengers.length || policy.guests.length) && <div className="itours-table-holder responsive-table margin-top">
                                        <table className="itours-table">
                                            <thead>
                                                <tr>
                                                    <th> عنوان </th>
                                                    <th> قیمت</th>
                                                    <th> توضیحات </th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {policy.passengers.map((passenger, passengerIndex) => (
                                                    <tr key={passengerIndex}>
                                                        <td className='text-center semi-bold'>
                                                            {passenger.name}
                                                        </td>
                                                        <td className={`text-center ${passenger.value === "مجانی" ? "green" : ""}`}>
                                                            {passenger.value}
                                                        </td>
                                                        <td>
                                                            {passenger.description}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {policy.guests.map((guest, guestIndex) => (
                                                    <tr key={guestIndex}>
                                                        <td className='p-3 whitespace-nowrap text-center semi-bold'>
                                                            {guest.name}
                                                        </td>
                                                        <td className='p-3 text-center'>
                                                            {guest.value}
                                                        </td>
                                                        <td className='p-3 min-w-400'>
                                                            {guest.description}
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>}
                                </div>
                            )}

                        </Fragment>)}

                        {!!mendatoryFee && (<Fragment>

                            <hr className='margin-top margin-bottom' />

                            <div className='semi-bold margin-bottom-half font-15'>
                                <ReportIcon className='inline-block-middle margin-end-light' />
                                قوانین کلی هتل
                            </div>

                            <div className='sm:col-span-2 md:col-span-3 lg:col-span-4 inserted-content'>
                                {parse(mendatoryFee)}
                            </div>

                        </Fragment>)}


                    </div>
                </div>
            </div>

        </>

    )
}

export default AccomodationPolicy;